import { render, staticRenderFns } from "./ErrorResolvedIssue.vue?vue&type=template&id=11ee352c&scoped=true&"
import script from "./ErrorResolvedIssue.vue?vue&type=script&lang=js&"
export * from "./ErrorResolvedIssue.vue?vue&type=script&lang=js&"
import style0 from "./ErrorResolvedIssue.vue?vue&type=style&index=0&id=11ee352c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ee352c",
  null
  
)

export default component.exports